var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('LoginLogout'),_c('div',[_c('VideoPlayer',{attrs:{"ott":_vm.$route.query.ott}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }